import { Form, InputGroup } from "react-bootstrap";
import "intl-tel-input/build/css/intlTelInput.css";
import "intl-tel-input/build/js/utils.js";
import intlTelInput from "intl-tel-input";
// import cssCls from "./Invite.module.css";
import { useContext, useEffect } from "react";
import { TicketContext } from "../../store/ticket-context";
import { useState } from "react";
import { DomainDataContext } from "../../store/domaindata-context";
import { allowedCountriesDialCodePattern } from "../../constants/constants";

const WhatsappForm = (props) => {
  // const [eneteredPhone, setEnteredPhone] = useState({
  //   phone: "",
  //   country: "+1",
  //   isocode: "us",
  //   fullVal: "",
  //   isValidnumber: false,
  // });
  const [WhatsappInputval, setWhatsappInputval] = useState(false);

  const ticket = useContext(TicketContext);
  const domainData = useContext(DomainDataContext);
  let Whatsappinput;
  let eneteredPhone = {
    phone: "",
    country: "+1",
    isocode: "us",
    fullVal: "",
    isValidnumber: false,
  };

  useEffect(() => {
    // console.error(ticket);
    if (domainData !== null) {
      eneteredPhone = {
        phone: eneteredPhone.phone,
        country: domainData.data.ISOCODE,
        isocode: domainData.data.COUNTRYCODE.toLocaleLowerCase(),
        fullVal: eneteredPhone.phone,
        isValidnumber: false,
      };
      console.error("after domain");
      console.error(eneteredPhone);
      // setEnteredPhone(eneteredPhone);
      props.sendWhatsappnumber(eneteredPhone);
    }
    console.error(ticket);
    if (ticket !== null) {
      eneteredPhone = {
        phone: ticket.phone,
        country: eneteredPhone.country,
        isocode: eneteredPhone.isocode,
        fullVal: ticket.phone,
        isValidnumber: false,
      };
      if (ticket.phone.trim().length > 1) {
        eneteredPhone.isValidnumber = true;
      }
      console.error("after ticket");
      console.error(eneteredPhone);
      // setEnteredPhone(eneteredPhone);
      props.sendWhatsappnumber(eneteredPhone);
    }
    console.error("set obj");

    Whatsappinput = document.getElementById("Whatsappinput");
    setWhatsappInputval(Whatsappinput);
    console.error("after ticket 2");
    console.error(eneteredPhone);
    window.Whatsappiti = intlTelInput(Whatsappinput, {
      autoHideDialCode: true,
      separateDialCode: false,
      formatOnDisplay: true,
      utilsScript: "./utils.js",
    });
    var phoneNumber = ''
    if (eneteredPhone.phone.trim().length > 1) {
       phoneNumber = eneteredPhone.phone;
      var patternMob = /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi;
      var isnonvalid = patternMob.test(phoneNumber);
      if (isnonvalid) {
        phoneNumber = phoneNumber.replace(
          /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi,
          ""
        );
        Whatsappinput.value = phoneNumber;
        eneteredPhone.isValidnumber = false;
      } else {
        eneteredPhone.isValidnumber = true;
      }

      var matchedCountryCode = phoneNumber.match(
        allowedCountriesDialCodePattern
      );
      if (matchedCountryCode && matchedCountryCode.length > 0) {
        // window.Whatsappiti.setNumber(phoneNumber);
        let newNumber = phoneNumber.substring(matchedCountryCode[0].length);
        phoneNumber = newNumber;
        console.error(newNumber);
        var countryData = window.intlTelInputGlobals.getCountryData();
        console.error(countryData);
        for (var i = 0; i < countryData.length; i++) {
          if (countryData[i].dialCode == matchedCountryCode[1]) {
            eneteredPhone.isocode = countryData[i].iso2;
            eneteredPhone.country = countryData[i].dialCode;
          }
        }

        eneteredPhone.phone = newNumber;
      } else {
        // window.Whatsappiti.setNumber(phoneNumber);
      }
    }
    // window.Whatsappiti.setNumber(eneteredPhone.phone);
    window.Whatsappiti.setCountry(eneteredPhone.isocode);
    if(phoneNumber.length > 0){
      window.Whatsappiti.setNumber(phoneNumber);
    }
   
    // setEnteredPhone(eneteredPhone);
    console.log(domainData.data.COUNTRYCODE);
    props.sendWhatsappnumber(eneteredPhone);
  }, [domainData, ticket]);

  const handleOnChange = (event) => {
    var countryData = window.Whatsappiti.getSelectedCountryData();

    var phoneNumber = WhatsappInputval.value;
    var patternMob = /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi;
    var isnonvalid = patternMob.test(phoneNumber);
    if (isnonvalid) {
      phoneNumber = phoneNumber.replace(
        /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi,
        ""
      );
      WhatsappInputval.value = phoneNumber;
    }

    var matchedCountryCode = phoneNumber.match(allowedCountriesDialCodePattern);
    if (matchedCountryCode && matchedCountryCode.length > 0) {
      window.Whatsappiti.setNumber(phoneNumber);
      window.Whatsappiti.setNumber(
        phoneNumber.substring(matchedCountryCode[0].length)
      );
    }
    if (typeof window.intlTelInputUtils !== "undefined") {
      // utils are lazy loaded, so must check
      var currentText = window.Whatsappiti.getNumber(
        window.intlTelInputUtils.numberFormat.E164
      );
      if (typeof currentText === "string") {
        // sometimes the currentText is an object :)
        window.Whatsappiti.setNumber(currentText); // will autoformat because of formatOnDisplay=true
      }
    }

    eneteredPhone = {
      phone: phoneNumber.trim(),
      country: countryData.dialCode,
      isocode: countryData.iso2,
      fullVal: window.Whatsappiti.getNumber().trim(),
      isValidnumber: false,
    };
    if (window.Whatsappiti.getNumber().trim()) {
      if (window.Whatsappiti.isValidNumber()) {
        eneteredPhone.isValidnumber = true;
      }
    }
    // setEnteredPhone(enteredVal);
    console.log(eneteredPhone);
    console.log(countryData);
    props.sendWhatsappnumber(eneteredPhone);
  };

  return (
    <div>
      <div className="invite-help-text">
        Select the country and enter the guest's mobile number to send an
        invitation.
      </div>
      <Form.Group className="mx-3 mb-3" controlId="formBasicWhatsapp">
        <InputGroup>
          <input
            type="text"
            id="Whatsappinput"
            onChange={handleOnChange}
            onBlur={handleOnChange}
            onFocus={handleOnChange}
            className="form-control"
            placeholder="Mobile Number"
          />
        </InputGroup>
      </Form.Group>
    </div>
  );
};

export default WhatsappForm;
